import { Flex, useMantineTheme } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { OptionProps } from 'react-select-modern';
import { components } from 'react-select-modern';

import type { Goal as GoalModel } from '@feathr/blackbox';
import { Text, UniversalSelect } from '@feathr/components';

import type { IGoalTypeOption } from '../../Goal.utils';
import { getGoalTypeOptions } from '../../Goal.utils';

interface IProps {
  goal: GoalModel;
}

function GoalTypeOption(props: OptionProps<IGoalTypeOption>): JSX.Element {
  const { data } = props;
  const {
    spacing: { '1': gap },
  } = useMantineTheme();
  return (
    <components.Option {...props}>
      <Flex direction={'column'} gap={gap}>
        <Text.DefaultHeadingMedium>{data.name}</Text.DefaultHeadingMedium>
        <Text.DefaultRegular>{data.description}</Text.DefaultRegular>
      </Flex>
    </components.Option>
  );
}

function GoalTypeSelect({ goal }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();
  const options = getGoalTypeOptions(t);

  function handleChangeGoalType({ id }: IGoalTypeOption): void {
    goal.set({ conv_type: id, segment: undefined, multi_conversions: false, conv_value: 5 });
  }

  return (
    <UniversalSelect<IGoalTypeOption>
      components={{ Option: GoalTypeOption }}
      label={t('Goal type')}
      onSelectSingle={handleChangeGoalType}
      options={options}
      value={options.find((option) => option.id === goal.get('conv_type'))}
    />
  );
}

export default observer(GoalTypeSelect);
